import React from "react";
import { connect } from "react-redux";
import { Popup, Button } from "devextreme-react";
import { openCloseModalEliminarCentro, doDeleteCentro } from "./action";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class ModalDelete extends React.PureComponent {
  handleCancel = () => {
    this.props.dispatch(openCloseModalEliminarCentro(false, {}));
  }

  handleEliminar = () => {
    this.props.dispatch(doDeleteCentro(this.props.centro));
  }

  render() {
    return (
      <Popup
        title="Eliminar centro médico"
        showCloseButton
        dragEnabled={false}
        onHiding={this.handleCancel}
        visible={this.props.isOpenModalEliminar}
        width={500}
        height={200}
        contentComponent={() => (
          <div className="modal-delete-mantenedor">
            {this.props.isLoading && <LoadingOverlay />}
            Esta acción es irreversible.
            <br />
            ¿Estás seguro de eliminar el centro?
            <div className="button-row">
              <div>
                <Button text="Cancelar" style={{ marginRight: 5 }} onClick={this.handleCancel} />
              </div>
              <div>
                <Button text="Eliminar" type="danger" onClick={this.handleEliminar} useSubmitBehavior />
              </div>
            </div>
          </div >
        )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isOpenModalEliminar: state.mantenedorCentros.isOpenModalEliminar,
  centro: state.mantenedorCentros.centro,
  isLoading: state.mantenedorCentros.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalDelete);
